import { Link } from 'gatsby';
import React, { useState } from 'react';
import { QB_ROOT_PATH } from '@src/constants/config';
import { Hits } from 'react-instantsearch';
import type { Hit } from 'instantsearch.js';
import { removeHyphens } from '@src/utils/utils';
import Lightbox from 'yet-another-react-lightbox';
import { WorksheetCheckbox } from 'components/WorksheetMaker';
import MagnifyIcon from '../../assets/icons/magnify.svg';
import * as styles from '../../pages/question-bank/question-bank.module.css';
import { questionBankHitsActions } from '@src/stores/question-bank-hits.store';
import { useParams } from './hooks';
import posthog from 'posthog-js';

type HitProps = {
  hit: Hit;
  onClick?: () => void;
};

function HitMe({ hit, onClick }: HitProps) {
  const slug = `/question-bank/${hit.slug}`;
  const imgSrc = `${QB_ROOT_PATH}${hit.image_question}`;

  const [open, setOpen] = useState(false);

  const close = () => {
    setOpen(false);
  };

  const title = `${removeHyphens(hit.series)} - ${removeHyphens(hit.paper)} -  Q${
    hit.question_number
  }`;

  return (
    <div>
      <div style={{ padding: '10px' }}>
        <WorksheetCheckbox
          hit={{
            title,
            slug: hit.slug,
          }}
        />
      </div>

      <div className={styles.hitHeader}>
        <Link to={slug} onClick={onClick}>
          {removeHyphens(hit.series)} - {removeHyphens(hit.paper)}
          <div>
            Question {hit.question_number} - {hit.difficulty}
          </div>
        </Link>
      </div>
      <div className={styles.hitImage}>
        <button className={styles.magnify} onClick={() => setOpen(true)}>
          <span>Enlarge Image</span>
          <img src={MagnifyIcon} alt="Enlarge Paper" />
        </button>

        <Link to={slug} onClick={onClick}>
          <img className="my-3" src={imgSrc} alt="Paper" />
        </Link>

        <Lightbox
          open={open}
          className={styles.lightbox}
          close={close}
          carousel={{
            finite: true,
          }}
          slides={[
            {
              src: imgSrc,
              width: 1000,
            },
          ]}
        />
      </div>
      <div className={styles.hitFooter}>
        <Link to={slug} onClick={onClick}>
          <p>{hit.area.join(', ')}</p>
          {/* <p>{hit.subtopic.join(', ')}</p> */}
        </Link>
      </div>
    </div>
  );
}

const HitList = () => {
  const { params, hits, nbPages } = useParams();

  const handleClick = (id) => {
    posthog.capture('question_bank_question_opened', { question_id: id });
    questionBankHitsActions.setCurrentHitId(id);
    questionBankHitsActions.setSnapshot(params, hits, params.page, nbPages);
  };

  return (
    <Hits
      hitComponent={({ hit }) => <HitMe hit={hit} onClick={() => handleClick(hit.id)} />}
      classNames={{
        list: styles.hitList,
        item: styles.hitItem,
      }}
    />
  );
};

export default HitList;
